<template>
    <layout v-bind:user="user" v-bind:company="company" :title="title" @selectList="displaySelectedBrand($event)">
        <main class="ly_main"><div class="wrap"><div class="inner">
            <!--Heading-->
            <h1 class="heading_page-title flex _y-center">
                <div class="main"><span>{{getTitle}}</span></div>
                <div class="controller flex _right _y-center">
                    <div class="form_search">
                        <form v-on:submit.prevent="search">
                            <input type="search" v-model="free_text">
                            <label for="submit-btn" class="md_svg-icon">
                                <SvgIconSearch />
                            </label>
                            <input type="submit" id="submit-btn">
                        </form>
                    </div><!--/.search-->
                </div><!--/.controller-->
            </h1><!--/.heading_page-title-->
            <!--ShopList-->
            <div class="md_common-bl" id="bland-list">
                <div class="inner">
                    <div class="table_common _use-checkbox">
                        <table>
                            <thead>
                                <tr>
                                    <th class="_pointer" @click="clickSort('id')">ID {{getTriangle('id')}}</th>
                                    <th class="_pointer" @click="clickSort('name')">{{getListName}} {{getTriangle('name')}}</th>
                                    <th class="_pointer" @click="clickSort('phonetic')">フリガナ {{getTriangle('phonetic')}}</th>
                                    <th class="_pointer" @click="clickSort('approval')">審査状況 {{getTriangle('approval')}}</th>
                                    <th class="_pointer" @click="clickSort('plan')">プラン {{getTriangle('plan')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in getList" :key="item.id">
                                    <td v-if="pageType == 1"><a class="" :href="route('admin.shop.detail', item.id)">{{item.id}}</a></td>
                                    <td v-if="pageType == 2"><a class="" :href="route('admin.brand.detail', item.id)">{{item.id}}</a></td>
                                    <td v-if="pageType == 3"><a class="" :href="route('admin.showroom.detail', item.id)">{{item.id}}</a></td>

                                    <td v-if="pageType == 1"><a class="" :href="route('admin.shop.detail', item.id)">{{item.name}}</a></td>
                                    <td v-if="pageType == 2"><a class="" :href="route('admin.brand.detail', item.id)">{{item.name}}</a></td>
                                    <td v-if="pageType == 3"><a class="" :href="route('admin.showroom.detail', item.id)">{{item.name}}</a></td>

                                    <td v-if="pageType == 1"><a class="" :href="route('admin.shop.detail', item.id)">{{item.phonetic}}</a></td>
                                    <td v-if="pageType == 2"><a class="" :href="route('admin.brand.detail', item.id)">{{item.phonetic}}</a></td>
                                    <td v-if="pageType == 3"><a class="" :href="route('admin.showroom.detail', item.id)">{{item.phonetic}}</a></td>

                                    <template v-if="!item.type || item.type == 1">
                                        <td v-if="item.approval == 0"><Link class="" :href="route(getRoutePriceZone, item.id)">審査待ち</Link></td>
                                        <td v-else-if="item.approval == 1"><Link class="" :href="route(getRoutePriceZone, item.id)">承認済</Link></td>
                                        <td v-else-if="item.approval == 2"><Link class="" :href="route(getRoutePriceZone, item.id)">非承認</Link></td>
                                    </template>

                                    <template v-if="item.type == 2">
                                        <td>
                                            <select v-on:change="selectApproval($event, item)">
                                                <option value="" hidden>審査待ち</option>
                                                <option v-for="select_approval in select_approvals" v-bind:selected="select_approval.id == item.approval" v-bind:key="select_approval.id" v-bind:value="select_approval.id">{{ select_approval.name }}</option>
                                            </select>
                                        </td>
                                    </template>

                                    <td v-if="item.plan == 0">free</td>
                                    <td v-else-if="item.plan == 1">basic</td>
                                    <td v-else-if="item.plan == 2">premium</td>
                                    <td v-else-if="item.plan == 10">personal</td>
                                    <td v-else-if="item.plan == 11">unit</td>
                                </tr>
                            </tbody>
                        </table>
                        <pagination v-if="showPagination" :list="links" />
                    </div><!--/.table_common-->
                </div><!--/.md_common-bl-->
                <AlertModal
                    v-if="showAlertModal"
                    @close="closeAlertModal"
                    :title="alert_modal_title"
                    :message="alert_modal_message"
                    :mode="alert_modal_mode"
                />
            </div>
        </div></div><div class="heading_page-title-en"><span>{{backName}}</span></div></main>
    </layout>
</template>
<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import Pagination from '@/components/Admin/Pagination'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3'

    //Svg
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'

    import ScrollHint from 'scroll-hint';

    export default {
        components: {
            "layout": AdminLayout,
            "pagination": Pagination,
            "Link": Link,
            "AlertModal": AlertModal,
            "ScrollHint": ScrollHint,
            //Svg
            SvgIconSearch
        },
        props: {
            user: Object,
            company: Object,
            brands: Array,
            shops: Array,
            freeText: Array,
            listSorter: Object,
        },
        data() {
            return {
                free_text: '',
                showPagination: false,
                links: '',
                list_sorter: {column: "", order: ""},
                select_approvals: [
                    { id: 1, name: '承認'},
                    { id: 2, name: '非承認'},
                ],
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: '',
            }
        },
        computed: {
            getList()  {
                if (location.pathname == '/admin/shop/operation') {
                    if (this.shops.data) {
                        this.showPagination = true;
                        this.links = this.shops;
                    }
                    if (this.freeText) {
                        for(var i in this.shops.links) {
                            var link = this.shops.links[i];
                            if (link.url) {
                                link.url = link.url + '&freeText=' + this.freeText;
                            }
                        }
                    }
                    if (this.listSorter) {
                        this.addSorterToLinks(this.listSorter, this.shops.links);
                    }
                    return this.shops.data;
                } else if (location.pathname == '/admin/brand/operation') {
                    if (this.brands.data) {
                        this.showPagination = true;
                        this.links = this.brands;
                    }
                    if (this.freeText) {
                        for(var i in this.brands.links) {
                            var link = this.brands.links[i];
                            if (link.url) {
                                link.url = link.url + '&freeText=' + this.freeText;
                            }
                        }
                    }
                    if (this.listSorter) {
                        this.addSorterToLinks(this.listSorter, this.brands.links);
                    }
                    return  this.brands.data;
                } else if (location.pathname == '/admin/showroom/operation') {
                    if (this.brands.data) {
                        this.showPagination = true;
                        this.links = this.brands;
                    }
                    if (this.freeText) {
                        for(var i in this.brands.links) {
                            var link = this.brands.links[i];
                            if (link.url) {
                                link.url = link.url + '&freeText=' + this.freeText;
                            }
                        }
                    }
                    if (this.listSorter) {
                        this.addSorterToLinks(this.listSorter, this.brands.links);
                    }
                    return  this.brands.data;
                }
            },
            getTitle() {
                if (location.pathname == '/admin/shop/operation') {
                    return 'ショップ一覧';
                } else if (location.pathname == '/admin/brand/operation') {
                    return 'ブランド一覧';
                } else if (location.pathname == '/admin/showroom/operation') {
                    return 'ショールーム一覧';
                }
            },
            pageType() {
                if (location.pathname == '/admin/shop/operation') {
                    return 1;
                } else if (location.pathname == '/admin/brand/operation') {
                    return 2;
                } else if (location.pathname == '/admin/showroom/operation') {
                    return 3;
                }
            },
            getListName() {
                if (location.pathname == '/admin/shop/operation') {
                    return 'ショップ名';
                } else if (location.pathname == '/admin/brand/operation') {
                    return 'ブランド名';
                } else if (location.pathname == '/admin/showroom/operation') {
                    return 'ショールーム名';
                }
            },
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                } else if (this.user.type == 2) {
                    return 'ShowRoom';
                }
            },
            getRoutePriceZone() {
                if (location.pathname == '/admin/shop/operation') {
                    return 'admin.shop.price.zone';
                } else if (location.pathname == '/admin/brand/operation') {
                    return 'admin.brand.price.zone';
                } else if (location.pathname == '/admin/showroom/operation') {
                    return 'admin.showroom.price.zone';
                }
            },
        },
        mounted() {
            this.free_text = this.freeText;
            if(this.listSorter){
                this.list_sorter = this.listSorter;
            };

            new ScrollHint('.table_common');

        },
        methods: {
            search() {
                const form = reactive({
                    freeText: this.free_text,
                    listSorter: this.list_sorter
                })
                Inertia.get('operation', form, {
                    onSuccess: (page) => {
                        this.free_text = '';
                    },
                })
            },
            selectApproval(event, item) {
                var selectApprovalId = event.target.value;
                var id = item.id
                var url = '/admin/showroom/price-zone'

                const form = reactive({
                    id: id,
                    approval: selectApprovalId,
                    company_id: false,
                })
                Inertia.post(url, form, {
                    onSuccess: (page) => {
                        console.log(selectApprovalId);
                        if (selectApprovalId == 1) {
                            this.openAlertModal("success", '承認しました', '承認しました。'); // 確認済み
                        } else {
                            this.openAlertModal("success", '承認しませんでした', '承認しませんでした。'); // 確認済み
                        }
                    },
                })
            },
            clickSort(sorter){
                if(this.list_sorter.column !== sorter){ // 1回目クリックされたらascでソート
                    this.list_sorter.column = sorter;
                    this.list_sorter.order = "ASC";
                } else {
                    if(this.list_sorter.order == "ASC"){
                        this.list_sorter.order = "DESC"; // 2回目クリックされたらdescでソート
                    } else {
                        this.list_sorter.column = ""; // 3回目クリックされたらソートを外す
                        this.list_sorter.order = "";
                    }
                }
                const { column, order } = this.list_sorter;
                const form = reactive({
                    freeText: this.free_text,
                    listSorter: { column, order }
                })
                Inertia.get('operation', form);
            },
            addSorterToLinks(sorter, links){
                for(var i in links) {
                    var link = links[i];
                    if (link.url) {
                        link.url = link.url + `&listSorter[column]=${sorter.column}&listSorter[order]=${sorter.order}`;
                    }
                }
            },
            getTriangle(name){
                if(name == this.list_sorter.column){
                    return this.list_sorter.order == "ASC" ? "▼" : "▲";
                } else return "▼";
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            },
        }
    }
</script>
